import { render, staticRenderFns } from "./Pornhub.vue?vue&type=template&id=1bc936a9&scoped=true&"
import script from "./Pornhub.vue?vue&type=script&lang=js&"
export * from "./Pornhub.vue?vue&type=script&lang=js&"
import style0 from "./Pornhub.vue?vue&type=style&index=0&id=1bc936a9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc936a9",
  null
  
)

export default component.exports